import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_PAYROLL_EMPLOYEE_DEDUCTION_REQUEST =
  "GET_PAYROLL_EMPLOYEE_DEDUCTION_REQUEST";
export const GET_PAYROLL_EMPLOYEE_DEDUCTION_SUCCESS =
  "GET_PAYROLL_EMPLOYEE_DEDUCTION_SUCCESS";
export const GET_PAYROLL_EMPLOYEE_DEDUCTION_ERROR =
  "GET_PAYROLL_EMPLOYEE_DEDUCTION_ERROR";

//* ACTIONS ------------------------------------------------
export const getPayrollEmployeeDeductionRequest = (payload = {}, callback) => ({
  type: GET_PAYROLL_EMPLOYEE_DEDUCTION_REQUEST,
  payload,
  callback,
});

export const getPayrollEmployeeDeductionSuccess = (data) => ({
  type: GET_PAYROLL_EMPLOYEE_DEDUCTION_SUCCESS,
  payload: data,
});

export const getPayrollEmployeeDeductionError = (error) => ({
  type: GET_PAYROLL_EMPLOYEE_DEDUCTION_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getPayrollEmployeeDeductionServiceRequest = async (
  deductionId
) => {
  const options = await withToken({
    method: Methods.GET,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/employee/deductions/${deductionId}`, options);
};
